import { CellProps } from 'react-table'
import { PacienteList } from '../../core/_models'
import { PacienteActionsCell } from './PacienteActionsCell'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { formatDocumentoPrincipal } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const PacienteColumns = (t: TFunction): ReadonlyArray<TableColumn<PacienteList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<PacienteList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar paciente ${row.original.pessoa?.nome ?? ''}`}
      />
    ),
  },
  // Nome com o documento como apoio (só o nome ordena, como antes).
  sortableColumn<PacienteList>({
    id: 'pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'pessoa.nome', label: t('cols.nome') },
      { field: 'pessoa.documentos', label: t('cols.documento'), sortable: false },
    ],
    Cell: ({ row }: CellProps<PacienteList>) => (
      <StackedCell
        primary={row.original.pessoa?.nome}
        secondary={formatDocumentoPrincipal(row.original.pessoa?.documentos)}
      />
    ),
  }),
  sortableColumn<PacienteList>({
    id: 'prontuario',
    cellWidth: '140px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'prontuario', label: t('cols.prontuario') }],
    Cell: ({ row }: CellProps<PacienteList>) => (
      <StackedCell tabular primary={row.original.prontuario} />
    ),
  }),
  sortableColumn<PacienteList>({
    id: 'pessoa.dataNascimento',
    cellWidth: '150px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'pessoa.dataNascimento', label: t('cols.dataNascimento') }],
    Cell: ({ row }: CellProps<PacienteList>) => (
      <StackedCell tabular primary={row.original.pessoa?.dataNascimentoFormatada} />
    ),
  }),
  sortableColumn<PacienteList>({
    id: 'empresa.nomeFantasia',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'empresa.nomeFantasia', label: t('empresa.label') }],
    Cell: ({ row }: CellProps<PacienteList>) => (
      <StackedCell primary={row.original.empresa?.nomeFantasia} />
    ),
  }),
  sortableColumn<PacienteList>({
    id: 'ativo',
    cellWidth: '120px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.situacao') }],
    Cell: ({ row }: CellProps<PacienteList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '220px',
    align: 'end',
    Cell: ({ row }: CellProps<PacienteList>) => <PacienteActionsCell paciente={row.original} />,
  },
]
